import axios from "axios";

import Config from "../config";

const api = Config.API + "/api/v1";

export const getLandingPageStructure = async (token) => {
  const apiUrl = api + "/runtime/" + token;

  const config = {
    headers: {
      "content-type": "application/json",
    },
  };

  const res = axios.get(apiUrl, config);

  return res;
};

export const sendSubmissionFromLandingPage = async (
  submissionFields,
  token
) => {
  const apiUrl = api + "/runtime/" + token + "/send";

  const config = {
    headers: {
      "content-type": "application/json",
    },
  };

  const data = submissionFields;

  const res = axios.put(apiUrl, data, config);


  return res;
};

export const verifyReCaptcha = async (token, verification) => {
  const apiUrl = api + "/runtime/" + token + "/check";

  const config = {
    headers: {
      "content-type": "application/json",
    },
  };

  const data = {
    value: verification,
  };

  const res = axios.put(apiUrl, data, config);


  return res;
};
